import React, { useEffect } from "react";
import styles from "./MisAccesos.module.scss";
import { connect } from "react-redux";
import { getPostulations } from "../../../../store/actions/index";
import { motion } from "framer-motion";
import ProfileEmptyState from "../ProfileEmptyState/ProfileEmptyState.tsx";
import PostulationItem from "../../../MainInfoItem/PostulationItem/PostulationItem";
import { useNavigate, useLocation } from "react-router-dom";
import { buildNavigationParams, getUserDisplayName } from "../../../../utils/navigationHelpers.ts";
import RegisteredUserProfileLoader from "../../../RegisteredUsers/RegisteredUsersSkeleton/RegisteredUserProfileLoader";

const MisAccesos = ({ getPostulations, postulaciones, postulationsLoading, myPerson, setInfoReady, userData }) => {

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        getPostulations();
    }, []);

    useEffect(() => {
        if (!postulationsLoading && postulaciones !== undefined) {
            setInfoReady(true);
        }
    }, [postulationsLoading, postulaciones, setInfoReady]);


    const handleOpenPostulation = (postulation) => {
        if (!postulation) return;
        const isFromProfile = location.pathname.startsWith('/perfil/');
        const userId = userData?.id ? String(userData.id) : null;
        const userName = getUserDisplayName(userData);
        if (isFromProfile && userId && userName) {
            const params = buildNavigationParams('Gestión', userId, userName, 'accesos');
            navigate(`/obrasprivadas/${postulation.proyecto.id}${params}`);
            return;
        }
        navigate(`/obrasprivadas/${postulation.proyecto.id}`);
    };

    return (
        <motion.section
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className={styles.container}
        >
            {postulationsLoading ? (
                <div className={styles.loadingContainer}>
                    <RegisteredUserProfileLoader />
                </div>
            ) : (
                postulaciones && postulaciones.length > 0 ? (
                    <div className={styles.container_body}>
                        {postulaciones.map((postulacion) => (
                            <PostulationItem
                            key={postulacion.id}
                            postulation={postulacion}
                            isPostulation
                            type="postulations"
                            myPerson={myPerson}
                            coverImage={postulacion.proyecto?.proyecto_images[0]?.image}
                            onOpen={handleOpenPostulation}
                            />
                        ))}
                    </div>
                ) : (
                    <ProfileEmptyState
                        illustration="accesos"
                        title="No tenés solicitudes de acceso a obras"
                        description="Cuando pidas acceso a una obra privada de otro usuario, el pedido queda registrado acá. Las postulaciones a vacantes laborales están en Gestión → Postulaciones laborales."
                    />
                )
            )}
        </motion.section>
    );
};

const mapStateToProps = (state) => ({
    postulaciones: state.profile.postulations,
    postulationsLoading: state.profile.postulationsLoading,
    userData: state.general.userData,
});

export default connect(mapStateToProps, { getPostulations })(MisAccesos);